import * as React from "react";
import { Lock, Users } from "lucide-react";

import type { Item } from "@/types/fse";
import type { DirectoryUsersById } from "./types";
import { formatSharingSummary } from "./utils";

interface Props {
  item: Item;
  authenticatedUserId: string;
  usersById: DirectoryUsersById;
  onOpenShare: (item: Item) => void;
}

export const DriveSharingSummary: React.FC<Props> = ({ item, authenticatedUserId, usersById, onOpenShare }) => {
  const label = formatSharingSummary(item, authenticatedUserId, usersById);
  const isPrivate = item.access === "restricted" && label === "Only you";
  const Icon = isPrivate ? Lock : Users;

  return (
    <button
      type="button"
      onClick={() => onOpenShare(item)}
      className="hover:text-midnight-blue inline-flex max-w-full items-center gap-1.5 text-xs text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral"
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span className="truncate">{label}</span>
    </button>
  );
};
